<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.1938 0.834375C11.4703 0.276562 12.0047 0 12.5391 0C13.0735 0 13.5297 0.276562 13.8062 0.834375L16.8672 7.04062L23.7156 8.03437C24.9437 8.2125 25.4359 9.72656 24.5453 10.5938L19.5906 15.4219L20.7625 22.2422C20.9734 23.4656 19.6844 24.3984 18.5875 23.8219L12.42 20.5L6.41252 23.8219C5.31565 24.3984 4.02658 23.4656 4.23752 22.2422L5.4094 15.4219L0.45471 10.5938C-0.435915 9.72656 0.0562723 8.2125 1.2844 8.03437L8.13283 7.04062L11.1938 0.834375Z" fill="#BABABA" />
  </svg>
</template>

<script>
  export default {}
</script>
